import * as React from "react";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import { Typography } from "@mui/material";

export default function ({ label, title, placement, sx }) {
  return (
    <Tooltip
      sx={sx}
      PopperProps={{
        sx: {
          "& .MuiTooltip-tooltip": {
            backgroundColor: "#1F1F1F",
            width: "52px",
            height: "36px",
            borerRadius: "4px",
            padding: "8px",
          },
          "& .MuiTooltip-arrow": {
            color: "#1F1F1F",
            width: "8px",
            height: "4px",
          },
        },
      }}
      placement={placement}
      title={
        <Typography
          variant="body2"
          fontWeight="400"
          fontSize="14px"
          lineHeight="20px"
          color="#EBEBEB"
        >
          {title}
        </Typography>
      }
      arrow
    >
      <Button>{label}</Button>
    </Tooltip>
  );
}
